
import { defineComponent, defineEmits, ref, reactive } from "vue";
import FormLabel from "../form-elements/includes/FormLabel.vue";
import FormErrors from "../form-elements/includes/FormErrors.vue";

export default defineComponent({
    name: "Select",
    components: {
        FormErrors,
        FormLabel
    },
    props: {
        id: {
            default: null,
            required: true,
            type: String
        },
        required: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            required: true,
        },
        labelClassName: {
            type: String,
            required: false,
            default: null
        },
        selectClassName: {
            type: String,
            required: false,
            default: null
        },
        name: {
            type: String,
            required: true,
        },
        options: {
            default: [],
            type: Array,
            required: false
        },
        selectedOption: {
            type: String,
            required: false,
            default: null
        },
        placeholder: {
            type: String,
            required: false,
            default: ""
        },
        changeValue: {
            type: Function,
            required: false,
            default: null
        },
        className: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: ['changeValue', 'update:modelValue'],
    setup(props, {emit}) {
        const onChangeValue = (e) => {
            emit('changeValue', e);
        }

        return {
            onChangeValue,
            errors: [],
        }
    },
});
